var render = function render(){var _vm=this,_c=_vm._self._c;return (this.input.customized.static_image || this.input.customized.images.length > 0)?_c('canvas',{ref:"imageSwitchCanvas",staticStyle:{"position":"absolute","width":"100%","height":"100%"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }